import React, {useEffect, useRef, useState} from "react";
import * as TestAPI from "../../../../../requests/TestAPI";
import {ITopic} from "../../../../types/ITopic";
import {ModalMessage} from "../../../common/ModalMessage";
import {toNumber} from "lodash";
import {IQuestion} from "../../../../types/IQuestion";
import {IAnswer} from "../../../../types/IAnswer";
import {IUpdateQuestionsRequest} from "../../../../types/IUpdateQuestionsRequest";
import {b64toBlob, getBase64} from "../../../../helpers/Util";
import {CONFIG} from "../../../../../CONFIG";
import SessionModel from "../../../../../stores/SessionModel";

interface IUploadErrors {
    errors: IUploadError[]
}

interface IUploadError {
    message?: string,
    rowNumber: number
}

export const UploadTopics: React.FC<{ testId: string }> = ({testId}) => {

    const [showSpinner, setShowSpinner] = useState(false);
    const [errors, setErrors] = useState<IUploadErrors>();
    const [errorMsg, setErrorMsg] = useState("");


    const handleUpload = (testId: string | undefined, e: React.ChangeEvent<HTMLInputElement>) => {
        if (!testId) return;
        const fileList = e.target.files;
        if (!fileList) return;
        if (fileList[0].size > 5200000) {
            setErrorMsg("Размер архива не должен превышать 5Мб.");
            return;
        }
        const formData = new FormData();
        setShowSpinner(true);
        formData.append("file", fileList[0], fileList[0].name);
        TestAPI.uploadTest(testId, formData, (response) => {
            if (response.status === 200) {
                window.location.reload();
            } else {
                setErrors(response.data);
                setShowSpinner(false);
            }
        });
    }


    return (
        <>
            <div className="container-right-block">
                <ModalMessage msg={errorMsg} header={"Ошибка"} _callback={() => setErrorMsg("")}/>
                <div className="test-theme-block">
                    <li className="first-message"><p
                        className="city">
                        Для загрузки теста выполните следующие действия:<br/>
                        1. Ознакомьтесь с инструкцией в <a href="#" target="_blank" className="active-link">текстовом формате</a> или <a href="#" target="_blank" className="active-link">видеоинструкцией.</a><br/>
                        2. Скачайте <a href="#" target="_blank" className="active-link">файл</a> с шаблоном таблицы и
                        заполните его согласно инструкции.<br/>
                        3. Загрузите сформированный архив в формате .zip. Файл не должен превышать 5 Мбайт.<br/></p></li>
                    {errors?.errors.map((e, index) =>
                        <div className="error-message" key={index}>Строка {e.rowNumber}: {e.message}</div>
                    )}
                    <label htmlFor={`upload-${testId}`} className="btn-main"
                           style={{display: "block", textAlign: "center"}}>
                        {showSpinner ? "Подождите...." : "Загрузить из файла"}
                        <input type="file" accept=".zip" onChange={(e) => showSpinner ? void(0) : handleUpload(testId, e)} name=""
                               id={`upload-${testId}`}
                               className="hidden"/>
                    </label>
                </div>
            </div>
        </>
    )

}